var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"submit-button",attrs:{"disabled":_vm.disabled || _vm.status}},[(_vm.status)?_c('loading'):_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }